import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { useEffect, useState } from 'react';

import { getChatsWidgetMicrofrontend } from '../../services/getChatsWidgetMicrofrontend/v1';
import { getChatsWidgetMicrofrontendV2 } from '../../services/getChatsWidgetMicrofrontend/v2';
import { useApplicationContext } from '../../utils/applicationContext';
import { checkCianMfRegistry } from '../../utils/checkCianMfRegistry';

export const useChatsWidgetMicrofrontend = () => {
  const context = useApplicationContext();
  const [manifest, setManifest] = useState<IMicrofrontendManifest | null>(null);
  const availableUrl = context.config.get<string[]>('chatsWidget.Enabled');
  const isEnabledV2 = context.config.get<boolean>('chatsWidgetV2.Enabled') || false;
  const isAllPagesEnabled = context.config.get<boolean>('chatsWidgetV2AllPages.Enabled') || false;

  useEffect(() => {
    if (isAllPagesEnabled && isEnabledV2 && checkCianMfRegistry()) {
      getChatsWidgetMicrofrontendV2(context).then(manifest => {
        setManifest(manifest);
      });

      return;
    }
    if (availableUrl?.includes(location.pathname) && checkCianMfRegistry()) {
      if (isEnabledV2) {
        getChatsWidgetMicrofrontendV2(context).then(manifest => {
          setManifest(manifest);
        });
      } else {
        getChatsWidgetMicrofrontend(context).then(manifest => {
          setManifest(manifest);
        });
      }
    }
  }, []);

  return { manifest };
};
